
import React from 'react';
import { Form, InputGroup, Col } from "react-bootstrap"
const Filter = (
{
    formType ="text",
    placeholder="",
    symbol="$",
    setCriteria = () => console.log("need to set filter criteria"),
}) =>
(
    <Col>
        <InputGroup>
            <InputGroup.Text>{symbol}</InputGroup.Text>
            <Form.Control
                type={formType}
                min={0}
                placeholder={placeholder}
                onChange={setCriteria} />
        </InputGroup>
    </Col>
)

export default Filter